module.exports = __webpack_public_path__ + "static/img/Tela de compra manual.a38403d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Screenshots/Tela de compra manual.png
// module id = zt8i
// module chunks = 0